import React from "react"
import styled from "styled-components"

const Title = styled.h2`
  color: ${props => props.color};
  text-transform: uppercase;
  margin-top: ${props => props.marginTop};
  margin-right: ${props => props.marginRight};
  margin-bottom: ${props => props.marginBottom};
  margin-left: ${props => props.marginLeft};
  text-align: ${props => props.textAlign};
  font-family: "Bellota Text", cursive;
`

const TitleH2 = ({content = "", marginTop = "30px", marginRight = "0", marginBottom = "30px", marginLeft = "0", textAlign = "auto", color = "#233467", children}) => {
    return <Title
        marginTop={marginTop}
        marginRight={marginRight}
        marginBottom={marginBottom}
        marginLeft={marginLeft}
        textAlign={textAlign}
        color={color}
    >
        {children}
        {content}
    </Title>
}

export default TitleH2
